export enum ProductTileContainer {
  PRODUCT_TILE_CONTAINER_UNKNOWN = 'PRODUCT_TILE_CONTAINER_UNKNOWN',
  CATEGORY_PRODUCT_RESULTS_GRID = 'CATEGORY_PRODUCT_RESULTS_GRID',
  SEARCH_PRODUCT_RESULTS_GRID = 'SEARCH_PRODUCT_RESULTS_GRID',
  BRAND_PAGE_NEW_ARRIVALS_CAROUSEL = 'BRAND_PAGE_NEW_ARRIVALS_CAROUSEL',
  CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL = 'CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL',
  HOMEPAGE_LAYOUT_ELEMENT_CAROUSEL = 'HOMEPAGE_LAYOUT_ELEMENT_CAROUSEL',
  SEARCH_RELATED_PRODUCT_RESULTS_GRID = 'SEARCH_RELATED_PRODUCT_RESULTS_GRID',
  SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND = 'SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND',
  PRODUCT_PAGE_PRODUCT_GRID = 'PRODUCT_PAGE_PRODUCT_GRID',
  PRODUCT_PAGE_LAYOUT_ELEMENT = 'PRODUCT_PAGE_LAYOUT_ELEMENT',
  BRAND_PAGE_PRODUCT_LIST = 'BRAND_PAGE_PRODUCT_LIST',
  BOARDS_SAVED_PRODUCT_GRID = 'BOARDS_SAVED_PRODUCT_GRID',
  BUY_AGAIN_PRODUCT_LIST = 'BUY_AGAIN_PRODUCT_LIST',
  CHECKOUT_BAG_DETAILS_PRODUCT_LIST = 'CHECKOUT_BAG_DETAILS_PRODUCT_LIST',
  BRAND_VIDEO_LIBRARY_PRODUCT_LIST = 'BRAND_VIDEO_LIBRARY_PRODUCT_LIST',
  SEARCH_BRAND_PRODUCT_RESULTS_GRID = 'SEARCH_BRAND_PRODUCT_RESULTS_GRID',
  MY_BRANDS_PRODUCT_LIST = 'MY_BRANDS_PRODUCT_LIST',
  PRODUCT_BASED_COLLECTION_LIST = 'PRODUCT_BASED_COLLECTION_LIST',
  BOARDS_SAVED_BRANDS_PRODUCT_CAROUSEL = 'BOARDS_SAVED_BRANDS_PRODUCT_CAROUSEL',
  USER_JOURNEY_BRAND_PAGE_CAROUSEL = 'USER_JOURNEY_BRAND_PAGE_CAROUSEL',
  PRODUCT_PAGE_TITLE_HEADER = 'PRODUCT_PAGE_TITLE_HEADER',
  CART_LAYOUT_ELEMENT_CAROUSEL = 'CART_LAYOUT_ELEMENT_CAROUSEL',
  SIMILAR_PRODUCTS_LAYOUT_ELEMENT_CAROUSEL = 'SIMILAR_PRODUCTS_LAYOUT_ELEMENT_CAROUSEL',
  SEARCH_PRODUCT_RESULTS_LAYOUT_ELEMENT = 'SEARCH_PRODUCT_RESULTS_LAYOUT_ELEMENT',
  POST_ORDER_PRODUCTS_FROM_SIMILAR_BRANDS = 'POST_ORDER_PRODUCTS_FROM_SIMILAR_BRANDS',
  DIGEST_PAGE_LAYOUT_ELEMENT = 'DIGEST_PAGE_LAYOUT_ELEMENT',
  BRAND_PAGE_BUY_IT_AGAIN_CAROUSEL = 'BRAND_PAGE_BUY_IT_AGAIN_CAROUSEL',
  /**
   * @deprecated
   */
  BRAND_INSIGHTS_PAGE_LIST = 'BRAND_INSIGHTS_PAGE_LIST',
  REORDER_BRAND_PAGE_INSIGHTS_CAROUSEL = 'REORDER_BRAND_PAGE_INSIGHTS_CAROUSEL',
  REORDER_BRAND_PAGE_ALL_BRANDS = 'REORDER_BRAND_PAGE_ALL_BRANDS',
  FOLLOWED_BRANDS_PRODUCTS = 'FOLLOWED_BRANDS_PRODUCTS',
  BRAND_VIDEO_PLAYER_PRODUCTS = 'BRAND_VIDEO_PLAYER_PRODUCTS',
  BRAND_PAGE_LAYOUT_ELEMENT = 'BRAND_PAGE_LAYOUT_ELEMENT',
  LOGGED_OUT_HOME_BESTSELLER_PRODUCTS_CAROUSEL = 'LOGGED_OUT_HOME_BESTSELLER_PRODUCTS_CAROUSEL',
  DISCOVER_PAGE_FEATURED_PRODUCTS_CAROUSEL = 'DISCOVER_PAGE_FEATURED_PRODUCTS_CAROUSEL',
  BUNDLES_PAGE_PRODUCTS_RESULTS = 'BUNDLES_PAGE_PRODUCTS_RESULTS',
  FULL_CART_RECOMMENDATIONS = 'FULL_CART_RECOMMENDATIONS',
  SIDE_CART_RECOMMENDATIONS = 'SIDE_CART_RECOMMENDATIONS',
  BRAND_PAGE_BUY_IT_AGAIN_GRID = 'BRAND_PAGE_BUY_IT_AGAIN_GRID',
  SEARCH_PRODUCT_RESULTS_IRRELEVANCE_CAROUSEL = 'SEARCH_PRODUCT_RESULTS_IRRELEVANCE_CAROUSEL',
  BRAND_PAGE_BUY_IT_AGAIN_LIST = 'BRAND_PAGE_BUY_IT_AGAIN_LIST',
  EXCLUSIVITY_PRODUCT_RECOMMENDATIONS = 'EXCLUSIVITY_PRODUCT_RECOMMENDATIONS',
  MERCHANDISED_COLLECTIONS_GRID = 'MERCHANDISED_COLLECTIONS_GRID',
  SEE_MORE_PAGE_RESULTS_GRID = 'SEE_MORE_PAGE_RESULTS_GRID',
  ASSORTMENT_PAGE_GRID = 'ASSORTMENT_PAGE_GRID',
  NOW_ON_FAIRE_PAGE_CAROUSEL = 'NOW_ON_FAIRE_PAGE_CAROUSEL',
  LOGGED_OUT_SEARCH_PRODUCT_RESULTS_GRID = 'LOGGED_OUT_SEARCH_PRODUCT_RESULTS_GRID',
  BUILDER_IO_GRID = 'BUILDER_IO_GRID',
  SEARCH_PRODUCT_RESULTS_BI_GRID = 'SEARCH_PRODUCT_RESULTS_BI_GRID',
  POST_CHECKOUT_LOW_MINIMUM_PRODUCTS_CAROUSEL = 'POST_CHECKOUT_LOW_MINIMUM_PRODUCTS_CAROUSEL',
}
